import {
  Component,
  OnInit,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import {Router } from '@angular/router';
import * as _ from 'underscore';
import {
  FormBuilder
} from '@angular/forms';
import { SearchComponent } from 'src/app/components/search/search.component';
import SwalAlert from 'src/app/utils/swalalert';
import { BlocksService } from 'src/app/api/report/blocks.service';
import { ToolsService } from 'src/app/utils/tools.service';

@Component({
  selector: 'app-blocksagency',
  templateUrl: './blocksagency.component.html',
  styleUrls: ['./blocksagency.component.css']
})
export class BlocksagencyComponent {
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private blocksService: BlocksService,
    public toolsService: ToolsService,
    private alert: SwalAlert
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    
  }

  ngOnInit() {
    this.list();
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page;
    this.blocksService.blocksAgencyList(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
        
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.list();
  }

  detail(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reportes/cuadresagencia/detalle',
      id
    ]);
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/reportes/lista'
    ]);
  }

}
